import { createI18n } from "vue-i18n";

import en from "./i18n/english.json";

const i18n = createI18n({
  locale: "en", // set locale
  fallbackLocale: "en",
  messages: { en }, // set locale messages
  legacy: false,
});

const loadedLanguages = new Set(["en"]); // our default language that is preloaded
export const languageMap: Record<string, string> = {
  en: "english",
  de: "german",
  ja: "japanese",
  ko: "korean",
  zh: "mandarin",
  es: "spanish",
  fr: "french",
  pt: "portuguese",
  nl: "dutch",
};

function setI18nLanguage(lang: string) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  i18n.global.locale.value = lang;
  // This is okay to ts-ignore because we use dynamic loading of languages
  return lang;
}

export async function loadLanguageAsync(fullLang: string): Promise<string> {
  const lang = fullLang.split("-")[0];
  if (i18n.global.locale.value === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }
  // If the language was already loaded
  if (loadedLanguages.has(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `./i18n/${languageMap[lang]}.json`).then((messages) => {
    i18n.global.setLocaleMessage(lang, messages.default);
    loadedLanguages.add(lang);
    return setI18nLanguage(lang);
  });
}

export default i18n;
